var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import Thumbnail from './thumbnail';
import { scrollTo, inArray } from '../../utils/util';
import Api2 from "../../utils/api2";
import Item from "./item";
import { useParams } from 'react-router-dom';
var Catalog = function () {
    var _a, _b;
    var item = useSelector(function (state) { return state.product.item; });
    var _c = useState(0), activeTab = _c[0], setActiveTab = _c[1];
    var _d = useState([]), catalogList = _d[0], setCatalogList = _d[1];
    var _e = useState([]), eventView = _e[0], setEventView = _e[1];
    var _f = useState(false), active = _f[0], setActive = _f[1];
    var _g = useState([]), goodsInfo = _g[0], setGoodsInfo = _g[1];
    var idx_b_manager = (useParams() || 1).idx_b_manager;
    useEffect(function () {
        CatalogSetFunc();
    }, [item]);
    var htmlSource = function (source, i, evt) {
        return typeof source === 'string' ? React.createElement("div", { key: i, dangerouslySetInnerHTML: { __html: source } }) : source;
    };
    var CatalogSetFunc = function () {
        if (!item)
            return null;
        var catalogArr = [];
        var eventViewArr = [];
        if (item.catalog.length > 0) {
            item.catalog.map(function (v, _i) {
                var catalog = htmlSource(v.item_info, v.producer_id);
                if (v.f_dp === 11 && v.producer_id === 3) {
                    catalogArr.push({ title: '제조사 제공', type: 'default', source: catalog, idx: 1 });
                }
                else if (v.f_dp === 11 && v.producer_id === 5) {
                    catalogArr.push({ title: '협력사 제공', type: 'default', source: catalog, idx: 1 });
                    eventViewArr.push(catalog);
                }
                else if (v.f_dp === 11 && v.producer_id === 6) {
                    catalogArr.push({ title: '기본 정보', type: 'default', source: catalog, idx: 1 });
                    eventViewArr.push(catalog);
                }
                else if (v.f_dp === 11 && v.producer_id === 7) {
                    catalogArr.push({ title: '제조사 이벤트', type: 'event', source: catalog, idx: 3 });
                    eventViewArr.push(catalog);
                }
                return true;
            });
        }
        if (item.cnt_img > 0) {
            var catalog = [];
            for (var i = 0; i < item.cnt_img; i++) {
                catalog.push(React.createElement(Thumbnail, { key: i, cid: item.cate_id, item_id: item.item_id, alt: item.full_item_name, size: "700", seq: i }));
            }
            catalogArr.push({ title: '해피트리', type: 'happytree', source: catalog, idx: 2 });
        }
        /**
         * TODO 카테고리 개선240131*/
        Api2.getCategoryItemInfo(item.item_id, idx_b_manager).then(function (res) {
            // console.log("@@@@@@@@@@API2정보",res)
            if (res) {
                if (item.cnt_img === 0) {
                    catalogArr.push({ title: '해피트리', type: 'happytree', source: [], idx: 2 });
                }
                setGoodsInfo(__spreadArray([], res.data.catalogs, true));
            }
        });
        if (item.event.length > 0) {
            item.event.map(function (v, i) {
                var evt_url = "".concat(process.env.REACT_APP_CDN_IMG, "/img_static/img_evt/").concat(v.idx_cat_evt, "/index.html");
                var catalog;
                var source = React.createElement(TransIframe, { evt_height: v.height_tit_p, src: evt_url, scrolling: "no" });
                if (v.f_tit === 1) {
                    catalog = source;
                }
                else if (v.f_tit === 0) {
                    catalog = (React.createElement("a", { key: i, href: "".concat(process.env.REACT_APP_EVENT_URL, "/eventview/") + v.idx_cat_evt, target: "_blank" },
                        React.createElement("img", { src: "".concat(process.env.REACT_APP_CDN_IMG, "/img_static/img_evt/") + v.idx_cat_evt + '/img/1904.jpg', alt: "", className: "evt_img", width: '100%' })));
                }
                catalogArr.push({ title: '이벤트', type: 'event', source: catalog, idx: 3 });
                if (eventViewArr.length === 0) {
                    eventViewArr.push(catalog);
                }
                return catalog;
            });
        }
        catalogArr.sort(function (a, b) {
            if (a.idx > b.idx) {
                return 1;
            }
            if (a.idx < b.idx) {
                return -1;
            }
            return 0;
        });
        setCatalogList(catalogArr);
        setEventView(eventViewArr);
    };
    if (!item || catalogList.length === 0)
        return null;
    var onClickImg = function () {
        setActive(function (s) { return !s; });
    };
    if (active) {
        scrollTo('.youtubeFrame', -120);
    }
    // 유튜브 링크가 있는 idx_b_manager
    var youtubeIdx = [8598, 4682];
    var youtubeUrl = 'https://www.youtube.com';
    var youtubeUrlDetail = {
        8598: '/embed/GsshlkwroZQ',
        4682: '/embed/F3pMglF-eZI',
    };
    idx_b_manager = ((_a = item === null || item === void 0 ? void 0 : item.minishop) === null || _a === void 0 ? void 0 : _a.idx_b_manager) || 1;
    var imageOnErrorHandler = function (event) {
        event.currentTarget.src = "".concat(process.env.REACT_APP_CDN_IMG, "/img_shopping/img_goods/img_no/no_img_minishop_shopping.png");
    };
    return (React.createElement(Style, null,
        React.createElement(Tabs, null, catalogList.map(function (v, i) { return (React.createElement(Tab, { type: "button", key: i, className: activeTab === i ? 'active' : '', onClick: function () { return setActiveTab(i); } }, v.title)); })),
        React.createElement(Contents, null, catalogList[activeTab].type !== 'happytree' ?
            React.createElement(Img, { cateId: item.cate_id.toString().substr(0, 1), pointer: !inArray(youtubeIdx, idx_b_manager) },
                (item.cate_id.toString().substr(0, 1) === '2' && catalogList[activeTab].idx === 2) &&
                    React.createElement("img", { className: 'mini', src: "".concat(process.env.REACT_APP_CDN_IMG, "/img_static/img_minishop_info/").concat((_b = item.minishop) === null || _b === void 0 ? void 0 : _b.idx_b_manager, ".jpg"), onError: imageOnErrorHandler, onClick: function () { return (!inArray(youtubeIdx, idx_b_manager)) && onClickImg(); }, alt: "".concat(idx_b_manager) }),
                React.createElement("div", { className: "youtubeFrame" }, (item.cate_id.toString().substr(0, 1) === '2' && catalogList[activeTab].idx === 2) && active &&
                    React.createElement(Iframe, { width: '950', height: '534', src: "".concat(youtubeUrl).concat(youtubeUrlDetail[idx_b_manager]), allow: "picture-in-picture" })),
                catalogList[activeTab].source)
            :
                React.createElement("div", { className: 'goodsInfo' }, goodsInfo.map(function (v, i) {
                    return (React.createElement(Item, { key: i, data: v }));
                })))));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 60px 0 0;\n\n"], ["\n    margin: 60px 0 0;\n\n"])));
var Tabs = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    height: 48px;\n    justify-content: flex-start;\n    border-bottom: 1px solid #333;\n"], ["\n    display: flex;\n    height: 48px;\n    justify-content: flex-start;\n    border-bottom: 1px solid #333;\n"])));
var Tab = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 140px;\n    height: 48px;\n    background: #f7f7fa;\n    font-size: 14px;\n    color: #999;\n    border: 1px solid #999;\n    border-bottom: 1px solid #333;\n\n    &:not(:first-child) {\n        border-left: none\n    }\n    &.active {\n        background: #fff;\n        font-weight: 700;\n        color: #333;\n        border-color: #333;\n        border-bottom-color: #ddd;\n        z-index: 1;\n    }\n"], ["\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 140px;\n    height: 48px;\n    background: #f7f7fa;\n    font-size: 14px;\n    color: #999;\n    border: 1px solid #999;\n    border-bottom: 1px solid #333;\n\n    &:not(:first-child) {\n        border-left: none\n    }\n    &.active {\n        background: #fff;\n        font-weight: 700;\n        color: #333;\n        border-color: #333;\n        border-bottom-color: #ddd;\n        z-index: 1;\n    }\n"])));
var Contents = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: 0 0 100px;\n    margin: 30px 0 0;\n    text-align: center;\n\n    .event_view {\n        margin: 0 0 40px;\n    }\n    .evt_img {\n        position: relative;\n        left: 50%;\n        transform: translate(-50%, 0);\n    }\n    .mini {\n        position: relative;\n        right: 5px;\n    }\n"], ["\n    padding: 0 0 100px;\n    margin: 30px 0 0;\n    text-align: center;\n\n    .event_view {\n        margin: 0 0 40px;\n    }\n    .evt_img {\n        position: relative;\n        left: 50%;\n        transform: translate(-50%, 0);\n    }\n    .mini {\n        position: relative;\n        right: 5px;\n    }\n"])));
var Img = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    background: ", ";\n    overflow-x: hidden;\n    overflow-y: hidden;\n\n    img {\n        cursor: ", ";\n        max-width:100%;\n        width:auto !important;\n        height:auto !important;\n    }\n"], ["\n    background: ", ";\n    overflow-x: hidden;\n    overflow-y: hidden;\n\n    img {\n        cursor: ", ";\n        max-width:100%;\n        width:auto !important;\n        height:auto !important;\n    }\n"])), function (props) { return (props.cateId == '2' ? '#efefef' : 'fff'); }, function (props) { return (props.pointer ? 'pointer' : 'default'); });
var Iframe = styled.iframe(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    border: 0\n"], ["\n    border: 0\n"])));
var TransIframe = styled.iframe(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-left: 50%;\n    transform: translateX(-50%);\n    width: 1190px;\n    height: ", "px;\n    transform-origin: 0 0;\n    border: 0\n"], ["\n    margin-left: 50%;\n    transform: translateX(-50%);\n    width: 1190px;\n    height: ", "px;\n    transform-origin: 0 0;\n    border: 0\n"])), function (props) { return props.evt_height; });
export default Catalog;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/catalog/index.tsx
// module id = 235
// module chunks = 0